export function update({ payload, params }) {
  return {
    url: `/api/companies/${params.id}`,
    method: 'PUT',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: payload,
  }
}

export function bank({ payload }) {
  return {
    url: `/api/company/bank_informations`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function getCompany({ id }) {
  return {
    url: `/api/companies/${id}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function getCompanies({ params }) {
  const formattedParams = new URLSearchParams()

  if (params.name && params.name !== '') {
    formattedParams.append('name', params.name)
  }

  return {
    url: `/api/companies?${formattedParams.toString()}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}

export function exportCourierHours({ params }) {
  const { companyId, start, end } = params || {}
  const search = new URLSearchParams()
  if (start) search.append('start', start)
  if (end) search.append('end', end)

  return {
    url: `/api/companies/${companyId}/courier_hours/export?${search.toString()}`,
    method: 'GET',
    headers: {
      // Expect XLSX stream from backend
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      Authorization: null,
    },
  }
}

export function hours({ params }) {
  return {
    url: `/api/companies/${params.id}/hours?date=${params.date}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
      Authorization: null,
    },
  }
}
